import { render, staticRenderFns } from "./ShopSkinEditComponent.vue?vue&type=template&id=72caaf56&scoped=true"
import script from "./ShopSkinEditComponent.vue?vue&type=script&lang=js"
export * from "./ShopSkinEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopSkinEditComponent.vue?vue&type=style&index=0&id=72caaf56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72caaf56",
  null
  
)

export default component.exports